import React, { useEffect } from "react";
import styles from "./SummaryHeader.module.scss";
import {
  FetchQuarryListParams,
  QuarryCategoriesType,
} from "../../../Types/quarryDatabaseTypes";
import { SummaryHeaderConstants, getGridColumnCount } from "./constants";
import QuarryDatabaseService from "../../../services/quarryDatabase.service";
import ConditionalRender from "../../../reusable-components/ConditionalRender";
import { Popover, Spin } from "antd";
import infoIcon from "../../../assets/images/info-icon.svg";
import { PlacementPositions } from "../../../enums/PlacementPositionsEnums";
import { ButtonSize } from "../../../enums/ButtonAttributesEnums";

interface SummaryHeaderProps {
  filters?: FetchQuarryListParams;
  countCallback?: (currentTotal) => void;
}

const SummaryHeader = ({ filters, countCallback }: SummaryHeaderProps) => {
  const { FetchQuarryDatabaseMeta } = QuarryDatabaseService();
  const { address, sortBy, sortOrder, ...cleanedFilters } = filters;
  const { data, refetch, isFetching } = FetchQuarryDatabaseMeta({
    ...cleanedFilters,
  });
  const { MAX_VISIBLE_ITEMS, TOTAL_QUARRY_LABEL, OTHERS_LABEL } =
    SummaryHeaderConstants;
  const categoryEntries = Object?.entries(data?.data?.categories ?? {});
  categoryEntries.sort((a, b) => b[1] - a[1]);
  const categoryCount = categoryEntries?.length;
  const visibleCategories = categoryEntries?.slice(
    0,
    categoryCount <= MAX_VISIBLE_ITEMS
      ? MAX_VISIBLE_ITEMS
      : MAX_VISIBLE_ITEMS - 1
  );
  const otherCategories = categoryEntries?.slice(
    categoryCount <= MAX_VISIBLE_ITEMS
      ? MAX_VISIBLE_ITEMS
      : MAX_VISIBLE_ITEMS - 1
  );
  const gridCols = getGridColumnCount(visibleCategories.length + 1);
  const popoverText = otherCategories?.map(([label, value]) => (
    <div>
      {label} - {value}
    </div>
  ));

  const layoutStyles = {
    gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
    "--grid-columns": gridCols,
  } as React.CSSProperties;

  const isFirstInRow = (index: number) => index % gridCols === 0;

  useEffect(() => {
    countCallback(data?.data?.quarryId);
  }, [data?.data]);

  return (
    <>
      <div className={styles.detailsCard} style={layoutStyles}>
        <ConditionalRender
          visible={!isFetching}
          fallback={
            <Spin size={ButtonSize.LARGE} className={styles.cardSpin} />
          }
        >
          <div className={styles.CategoryCard} style={{ borderLeft: "none" }}>
            <span className={styles.CategoryNumber}>{data?.data?.total}</span>
            <span className={styles.CategoryLabel}>{TOTAL_QUARRY_LABEL}</span>
          </div>
          {visibleCategories?.map(([label, value], index) => (
            <div
              key={label}
              className={styles.CategoryCard}
              style={
                isFirstInRow(index + 1) ? { borderLeft: "none" } : undefined
              }
            >
              <span className={styles.CategoryNumber}>{value}</span>
              <span className={styles.CategoryLabel}>{label}</span>
            </div>
          ))}
          <ConditionalRender visible={otherCategories?.length !== 0}>
            <div className={styles.otherCard}>
              {OTHERS_LABEL}
              <Popover
                content={popoverText}
                placement={PlacementPositions.LEFT}
              >
                <img src={infoIcon} />
              </Popover>
            </div>
          </ConditionalRender>
        </ConditionalRender>
      </div>
    </>
  );
};
export default SummaryHeader;
